import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SsrLocalstoreService } from 'src/app/_services/ssr-localstore.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-privacy-policy-dialog',
    templateUrl: 'privacy-policy-dialog.html',
    standalone: true
})
export class PrivacyPolicyDialogComponent implements OnInit {
    public safe_url: SafeResourceUrl = '';

    constructor(
        private sanitizer: DomSanitizer,
        public dialogRef: MatDialogRef<PrivacyPolicyDialogComponent>
    ) { }

    ngOnInit(): void {
        const url = 'https://www.bleachr.co/privacy';
        this.safe_url = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

@Component({
    selector: 'app-cookie-popup',
    templateUrl: './cookie-popup.component.html',
    styleUrls: ['./cookie-popup.component.scss'],
    standalone: true,
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatIcon]
})
export class CookiePopupComponent {
    @Output() acceptCookie: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<CookiePopupComponent>,
        private ssr: SsrLocalstoreService
    ) { }

    openPolicyDialog() {
        this.dialog.open(PrivacyPolicyDialogComponent, {
            width: '80%',
            height: '85%',
            panelClass: 'privacy-dialog'
        })
    }

    setCookie() {
        if (this.ssr.isClientSide) {
            document.cookie = 't1_privacy_policy=true';
            if (this.dialogRef) {
                this.dialogRef.close(true);
            } else {
                this.acceptCookie.emit(true);
            }
        }
    }
}